module.exports = __webpack_public_path__ + "static/media/university.85798c5a.svg";